import { useTranslation } from 'react-i18next';
import { InfoIcon, XIcon } from 'lucide-react';
import { Badge } from '@folio/components/ui/badge';
import { Button } from '@folio/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@folio/components/ui/tooltip';
import { Group } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';

export function ContextLabelBadge({
  displayName,
  isLoading,
  onDismiss,
}: {
  displayName: string | null;
  isLoading: boolean;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();

  if (!displayName && !isLoading) return null;

  return (
    <Group gap={0} className="gap-1.5 px-4 pt-3">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" className="h-6 w-6 shrink-0">
            <InfoIcon className="h-3.5 w-3.5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <Text size="xs" className="max-w-[250px]">
            {t('conversation.contextBadgeTooltip')}
          </Text>
        </TooltipContent>
      </Tooltip>
      <Badge variant="secondary" className="gap-1 pr-1.5">
        <Text inline truncate className="max-w-[250px]">
          {isLoading && !displayName ? '…' : displayName}
        </Text>
        <Button
          variant="ghost"
          size="icon"
          className="ml-0.5 h-4 w-4 rounded-full hover:bg-destructive/20"
          onClick={e => {
            e.stopPropagation();
            onDismiss();
          }}
        >
          <XIcon className="h-3 w-3" />
        </Button>
      </Badge>
    </Group>
  );
}
